import { onlineManager } from '@tanstack/react-query';
import { ApiResponse } from 'apisauce';
import { orderConditionRepositoryOfflineAdapters } from '../../../modules/offline/offlineRequestAdapters/orderCondition.repository.offlineAdapters';
import { GetOrderConditionDTO } from '../../../modules/orders/conditions/dtos/orderCondition.dto';
import OrderConditionCustomFieldConfig from '../../../modules/orders/conditions/interfaces/orderConditionCustomFieldConfig.interface';
import { restApi } from '../../api';
import { FindClassificationTypesOutput } from '../classificationTypes/classificationTypes.types';
import {
  FindOrderConditionFreightQuotesParams,
  FindOrderConditionParams,
  FindOrderConditionsClassificationTypesParams,
  OrderConditionFreightQuote,
} from './orderCondition.types';

export const findOrderConditions = ({
  isOfflineMode,
  ...params
}: FindOrderConditionParams): Promise<ApiResponse<GetOrderConditionDTO[]>> =>
  isOfflineMode || !onlineManager.isOnline()
    ? orderConditionRepositoryOfflineAdapters.findOrderConditions(params)
    : restApi.get<GetOrderConditionDTO[]>(`orders/${params.orderId}/order-conditions`, {
        hasOrderItems: true,
      });

export const findOrderConditionsCustomFields = () =>
  restApi.get<OrderConditionCustomFieldConfig[]>(`orders/order-conditions/custom-fields`);

export const findOrderConditionsClassificationTypes = (
  params: FindOrderConditionsClassificationTypesParams,
) =>
  restApi.get<FindClassificationTypesOutput>(
    `orders/order-conditions/classification-types`,
    params,
  );

export const findOrderConditionFreightQuotes = ({
  orderId,
  orderConditionId,
}: FindOrderConditionFreightQuotesParams) =>
  restApi.get<OrderConditionFreightQuote[]>(
    `orders/${orderId}/order-conditions/${orderConditionId}/freight-quotes`,
  );
